enum User {
  None,
  Client,
  Skipper,
  Crew,
  Admin,
}

export default User;
